'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { ProgressiveImageBase } from './progressive-image-base.component.js';
import { ErrorBoundary } from '../error-boundary/error-boundary.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
let a = {
    onError: t.func,
    trigger: t.oneOfType([
        t.oneOf([
            'immediate',
            'inView'
        ]),
        t.number
    ]),
    children: t.func,
    placeholder: t.string
}, l = [
    'trigger',
    'intersectionOptions'
];
const ProgressiveImage = renderWithRef('ProgressiveImage', a, (r, c)=>{
    let { children: a, onError: m, placeholder: f = '', src: b = '', srcSet: u, sizes: y, trigger: d = 'inView', intersectionOptions: O = {
        threshold: 0
    } } = r, [g, j] = useState({
        delay: 0,
        src: null != f ? f : '',
        sizes: void 0,
        srcSet: void 0
    }), { ref: w, inView: v } = useInView(_object_spread_props(_object_spread({}, O), {
        triggerOnce: true
    }));
    useEffect(()=>{
        'immediate' === d || 'inView' === d && v ? j({
            src: b,
            srcSet: u,
            sizes: y,
            delay: 0
        }) : 'number' == typeof d && j({
            src: b,
            srcSet: u,
            sizes: y,
            delay: d
        });
    }, [
        d,
        b,
        u,
        y,
        v
    ]);
    let P = new Set([
        'swan-progressive-image-wrapper'
    ]);
    return jsx(ErrorBoundary, {
        fallback: a({
            src: b
        }, false),
        children: jsx(RenderComp, {
            root: "div",
            propKeysToRemove: l,
            forwardedRef: w,
            props: r,
            classNames: P,
            children: jsx(ProgressiveImageBase, {
                src: g.src,
                placeholder: null != f ? f : '',
                srcSetData: {
                    srcSet: g.srcSet || '',
                    sizes: g.sizes || ''
                },
                delay: g.delay,
                onError: (e)=>{
                    m && m(e);
                },
                children: (e, r, t)=>a({
                        src: e,
                        srcSet: null == t ? void 0 : t.srcSet,
                        sizes: null == t ? void 0 : t.sizes
                    }, 'immediate' !== d && 'inView' === d && !v || r)
            })
        })
    });
});

export { ProgressiveImage };
